import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "../../Global/Scroll";
import { errorMessages } from "../../../Constants/Errors";
import { category_page_labels } from "../../../Constants/Labels";
import {
    categories_page_message,
    alert_message_type,
} from "../../../Constants/Messages";
import { callAPI, useStore, usePage, useUser } from "../../../Utils/utils";
import Message from "../../Message/Message";
import Alert from "../../Alert/Alert";
import { PopUpMessage } from "../../Global/PopupMessage/PopupMessage";
import ImageSelector from "../../ImageSelector/ImageSelector";
import ImagesPreview from "../../ImagesPreview/ImagesPreview";
import ErrorMessage from "../../Global/ErrorMessage";
import "./CategoryEdit.css";

export default function CategoryEdit({ onUpdateCategory }) {
    var { id } = useParams();
    const navigate = useNavigate();
    const { page, setPage } = usePage();
    const { user, setUser } = useUser();
    const { store, setStore } = useStore();
    const [errors, setErrors] = useState();
    const [payLoad, setPayLoad] = useState();
    const [mode, setMode] = useState("list");
    const [alert, setAlert] = useState();
    const [loading, setLoading] = useState(false);
    const [lineItems, setLineItems] = useState([]);
    const [storeName, setStoreName] = useState([]);
    const [formValues, setformValues] = useState({});
    const [productList, setProductList] = useState([]);
    const [savedImages, setSavedImages] = useState([]);
    const [addedProducts, setAddProducts] = useState([]);
    const [imageSelector, setImageSelector] = useState();
    const [selectedImages, setSelectedImages] = useState([]);
    const [defaultProduct, setDefaultProduct] = useState([]);
    const [removeProducts, setRemoveProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [searchProductName, setSearchProductName] = useState("");
    const [updatedFormValues, setUpdatedFormValues] = useState();
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [categoryBasedProduct, setCategoryBasedProduct] = useState([]);
    const [openDelectPopup, setOpenDelectPopup] = useState();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        if (storeName?.length == 0 || storeName == undefined) {
            setStoreName(() => [store?.name]);
        } else {
            setStoreName((existingStoreId) => [...existingStoreId, store?.name]);
        }
    }, [store?.id]);

    useEffect(() => {
        if (storeName[1] != undefined) {
            if (storeName[0] != storeName[1]) {
                navigate("/admin");
                setStoreName([]);
            }
        }
    }, [storeName]);

    // set the loading status into context whenever loading value changes
    useEffect(() => {
        setPage({ isLoading: loading });
    }, [loading]);

    // store onchage value in state
    const onChangeField = (event) => {
        const { name, value, type, checked } = event.target;
        const fieldValue = type === "checkbox" ? checked : value;

        // If is_parent_category changes to true, clear parent_category_id
        if (name === "is_parent_category" && checked) {
            setformValues({
                ...formValues,
                [name]: fieldValue,
                parent_category_id: null,
            });
            setUpdatedFormValues({
                ...formValues,
                [name]: fieldValue,
                parent_category_id: null,
            });
        } else {
            setformValues({ ...formValues, [name]: fieldValue });
            setUpdatedFormValues({ ...formValues, [name]: fieldValue });
        }

        // hide errors
        setShowErrorMessage(false);
        setErrors([]);
    };

    // onclick to  validate check require fields and post Storedata database
    useEffect(() => {
        if (id && store?.id) {
            callAPI(
                `/admin/category/${id}`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        token: user?.auth_token,
                    },
                    body: JSON.stringify({
                        vendor_id: store?.id
                    })
                },
                navigate,
                setLoading,
            ).then((data) => {
                if (data.success === true) {
                    setformValues({
                        ...data.record,
                        is_parent_category: data.record?.parent_category_id ? false : true,
                    });
                    if (
                        data?.record?.category_image &&
                        data?.record?.category_image?.path &&
                        data?.record?.category_image?.name
                    ) {
                        setSavedImages([
                            {
                                image_id: data?.record?.category_image?.image_id,
                                path: data?.record?.category_image?.path,
                                name: data?.record?.category_image?.name,
                            },
                        ]);
                    } else {
                        // console.log('data.errors', data.errors)
                    }
                }
            });
        }
    }, [store?.id]);

    console.log("form", formValues);

    // get data from database based on id on page onload
    useEffect(() => {
        if (id &&store?.id) {
            var pay_load = {
                category_id: id,
                vendor_id: store?.id,
            };
            callAPI(
                "/admin/category/products-for-category",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        token: user?.auth_token,
                    },
                    body: JSON.stringify(pay_load),
                },
                navigate,
                setLoading,
            ).then((data) => {
                if (data.success) {
                    setCategoryBasedProduct(data?.records);
                } else {
                    // console.log('Error occurred. Please try again.')
                }
            });
        }

        if (store?.id) {
            callAPI(
                "/admin/category/by-store",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        token: user?.auth_token,
                    },
                    body: JSON.stringify({
                        store_id: store?.id,
                        status: "active",
                        page_size: 100,
                        current_page: 1,
                    }),
                },
                navigate,
                setLoading,
            ).then((data) => {
                if (data.success) {
                    setCategories(data.records?.filter((cat) => cat.category_id != id));
                }
            });
        }
    }, [id, store?.id]);

    useEffect(() => {
        if (store?.id) {
            var inital_pay_load = {
                store_id: store?.id,
                status: "all",
                page_size: 10,
                current_page: 1,
            };
            var pay_load = payLoad || inital_pay_load;
            pay_load.page_size = 100;
            pay_load.current_page = 1;
            // console.log("pay_load", pay_load)
            callAPI(
                "/admin/products/by-store",
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        token: user?.auth_token,
                    },
                    body: JSON.stringify(pay_load),
                },
                navigate,
                setLoading,
            ).then((data) => {
                if (data.success) {
                    setProductList(data.records);
                    if (removeProducts?.length == 0 && defaultProduct?.length == 0) {
                        var categoryProduct = categoryBasedProduct?.map((Category) =>
                            data.records?.find(
                                (list) => list?.product_id == Category?.product_id,
                            ),
                        );
                        setDefaultProduct(categoryProduct);
                        setSelectedProducts(categoryProduct);
                        var newLineItems = [];
                        //display the items based on the selected products
                        categoryProduct?.map((selectedProduct) => {
                            if (selectedProduct) {
                                // Push a new object into newLineItems array
                                newLineItems.push({
                                    product_id: selectedProduct?.product_id,
                                    store_id: store?.id,
                                    name: selectedProduct?.name,
                                });
                            }
                        });

                        setLineItems(newLineItems);
                    }
                } else {
                    // console.log("errors", data.errors)
                }
            });
        }
    }, [categoryBasedProduct, store?.id, payLoad]);

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const items = Array.from(lineItems);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        setLineItems(items);

        // Also update selectedProducts and addedProducts to maintain consistency if needed,
        // but lineItems is what's displayed and used for order.
        const selected = Array.from(selectedProducts);
        const [reorderedSelected] = selected.splice(result.source.index, 1);
        selected.splice(result.destination.index, 0, reorderedSelected);
        setSelectedProducts(selected);

        // Call API to update order immediately
        const orderPayload = {
            vendor_id: store?.store_id || store?.id,
            category_id: id,
            products: items?.map((item) => item?.product_id),
        };
        callAPI(
            "/admin/vendor-categories/upsert",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    token: user?.auth_token,
                },
                body: JSON.stringify(orderPayload),
            },
            navigate,
            setLoading,
        );
    };

    // check the required fields and Posting the data to database.
    const saveCategory = (isCategoryDelete) => {
        // This enables smooth scrolling
        scrollToTop();

        // concat addedProducts and removeProducts
        var checkDuplicateProduct_id = addedProducts?.concat(removeProducts);
        // check duplicate values
        function findDuplicates(arr) {
            return arr?.filter(
                (currentValue, currentIndex) =>
                    arr?.indexOf(currentValue) !== currentIndex,
            );
        }
        // remove duplicate values in addedProducts and store in newProducts
        var newProducts = addedProducts;
        newProducts = newProducts?.filter(
            (item) => !findDuplicates(checkDuplicateProduct_id)?.includes(item),
        );
        // remove duplicate values in removeProducts and store in removeDefaultProducts
        var removeDefaultProducts = removeProducts;
        removeDefaultProducts = removeDefaultProducts?.filter(
            (item) => !findDuplicates(checkDuplicateProduct_id)?.includes(item),
        );

        //  updated values
        const payload = {
            category_id: id,
            store_id: store?.id,
            name: updatedFormValues?.name !== undefined ? updatedFormValues?.name?.trim() : formValues?.name?.trim(),
            description: updatedFormValues?.description !== undefined ? updatedFormValues?.description : formValues?.description,
            status: updatedFormValues?.status !== undefined ? updatedFormValues?.status : formValues?.status,
            added_products: newProducts,
            removed_products: removeDefaultProducts,
            parent_category_id:
                updatedFormValues?.parent_category_id !== undefined
                    ? updatedFormValues?.parent_category_id || null
                    : formValues?.parent_category_id || null,
            meta_title:
                updatedFormValues?.meta_title !== undefined
                    ? updatedFormValues?.meta_title
                    : (formValues?.meta_title || ""),
            meta_description:
                updatedFormValues?.meta_description !== undefined
                    ? updatedFormValues?.meta_description
                    : (formValues?.meta_description || ""),
        };

        if (selectedImages == null) {
            payload.image = null;
        } else if (selectedImages?.image_id) {
            payload.image = selectedImages?.image_id;
        }

        // console.log("payload", payload)

        callAPI(
            "/admin/category/update",
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    token: user?.auth_token,
                },
                body: JSON.stringify(payload),
            },
            navigate,
            setLoading,
        ).then((data) => {
            // console.log("api response " + JSON.stringify(data))
            if (data.success === true) {
                const orderPayload = {
                    vendor_id: store?.store_id || store?.id,
                    category_id: id,
                    products: lineItems?.map((item) => item?.product_id),
                };
                callAPI(
                    "/admin/vendor-categories/upsert",
                    {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            token: user?.auth_token,
                        },
                        body: JSON.stringify(orderPayload),
                    },
                    navigate,
                    setLoading,
                ).then((orderData) => {
                    if (isCategoryDelete == true) {
                        onCategoryDelete();
                    } else {
                        onUpdateCategory("success");
                    }
                });
            } else {
                setErrors(data?.errors);
                setShowErrorMessage(true);
                onUpdateCategory("error");
                // console.log("errors", data?.errors)
            }
        });
    };

    //get the product name during on change of the input value
    const onSearchProductName = (event) => {
        setSearchProductName(event.target.value);
        setMode("open");

        var pay_load = {
            store_id: store?.id,
            status: "all",
        };

        if (event.target.value) {
            pay_load.filters = {
                conditions: [
                    {
                        field: "p.name",
                        operator: "like",
                        value: event.target.value,
                        dataType: "string",
                    },
                ],
            };
        }
        setPayLoad(pay_load);
    };
    

    const onClickProductsList = () => {
        // Set the mode to 'open' to indicate that the search results should be displayed.
        setMode("open");
        var pay_load = {
            store_id: store?.id,
            status: "all",
        };
        setPayLoad(pay_load);
    };

    //get list of products when on click the search icon
    const onClickProductSearchIcon = () => {
        setMode("open");

        var pay_load = {
            store_id: store?.id,
            status: "all",
        };

        if (searchProductName) {
            pay_load.filters = {
                conditions: [
                    {
                        field: "p.name",
                        operator: "like",
                        value: searchProductName,
                        dataType: "string",
                    },
                ],
            };
        }

        setPayLoad(pay_load);
    };

    const onChangeFields = (event, product) => {
        if (
            selectedProducts?.length == 0 &&
            !selectedProducts?.some(
                (selectedProduct) =>
                    selectedProduct?.product_id === product?.product_id,
            )
        ) {
            setSelectedProducts([product]);
        } else if (
            selectedProducts?.length > 0 &&
            !selectedProducts?.some(
                (selectedProduct) =>
                    selectedProduct?.product_id === product?.product_id,
            )
        ) {
            setSelectedProducts([...selectedProducts, product]);
        } else {
            // Remove the unselected product from the selectedProducts list.
            setSelectedProducts(
                selectedProducts?.filter(
                    (selectedProduct) =>
                        selectedProduct?.product_id !== product?.product_id,
                ),
            );
        }

        if (
            defaultProduct?.some(
                (selectedProduct) => selectedProduct?.product_id === product.product_id,
            )
        ) {
            setDefaultProduct(
                defaultProduct?.filter(
                    (selectedProduct) =>
                        selectedProduct?.product_id !== product?.product_id,
                ),
            );
            if (removeProducts?.length == 0) {
                setRemoveProducts([product?.product_id]);
            } else if (removeProducts?.length != 0) {
                setRemoveProducts([...removeProducts, product?.product_id]);
            }
        }

        if (
            addedProducts?.length == 0 &&
            !defaultProduct?.some(
                (selectedProduct) => selectedProduct?.product_id === product.product_id,
            )
        ) {
            var addedProductsIds = [];
            addedProductsIds?.push(product?.product_id);
            setAddProducts(addedProductsIds);
        } else if (
            addedProducts?.length > 0 &&
            !addedProducts?.some((product_id) => product_id === product?.product_id)
        ) {
            setAddProducts([...addedProducts, product?.product_id]);
        } else {
            setAddProducts(
                addedProducts?.filter(
                    (selectedProduct) => selectedProduct !== product?.product_id,
                ),
            );
        }
    };

    //Add the selected products to line items
    const onClickAddLineItems = () => {
        var newLineItems = []; //array of objects
        var newLineItems1 = []; //array of objects
        // Check if a product with the same product_id exists in LineItems

        //display the items based on the selected products
        selectedProducts?.map((selectedProduct) => {
            if (selectedProduct) {
                // Push a new object into newLineItems array
                newLineItems.push({
                    product_id: selectedProduct?.product_id,
                    store_id: store?.id,
                    name: selectedProduct?.name,
                    price_per_item: selectedProduct?.price,
                    quantity: 1,
                });

                newLineItems1.push(selectedProduct?.product_id);
            }
        });

        setLineItems(newLineItems);
        setAddProducts(newLineItems1);
        setMode("close");
    };

    //remove the line items
    const onClickRemoveProduct = (productIndex, product_id) => {
        //remove the line item from the line items
        setLineItems(lineItems?.filter((v, i) => i != productIndex));
        // remove the line item from the selected products list
        setSelectedProducts(selectedProducts?.filter((v, i) => i != productIndex));
        setAddProducts(addedProducts?.filter((v, i) => i != productIndex));
        setRemoveProducts((previousproducts) => [...previousproducts, product_id]);
        setDefaultProduct(defaultProduct?.filter((v, i) => i !== productIndex));
    };

    //close the dropdown when click to cancel button
    const onClickCloseDropdown = () => {
        setMode("close");
        //clear the selected products when click to cancel button
        if (lineItems?.lenght == 0) {
            setSelectedProducts([]);
        } else if (lineItems?.lenght != 0) {
            setSelectedProducts(lineItems);
            if (selectedProducts?.length != lineItems?.lenght) {
                setAddProducts(lineItems?.map((product) => product?.product_id) || []);
            }
        }
    };

    const onOpen = (config) => {
        if(store?.is_separate_store){   
        setImageSelector(config);
        }
    };

    const onClose = () => {
        setImageSelector(false);
    };

    const onSelectImages = (images) => {
        setSelectedImages(images);
    };
    const onRemoveImageIds = () => {
        if(store?.is_separate_store){
        setSelectedImages(null);
        }
    };

    const status = Object.keys(
        category_page_labels?.category_add_and_edit_page_status,
    )?.map((name) => {
        const value = category_page_labels?.category_add_and_edit_page_status[name];
        return `${name},${value}`;
    });

    const onOpenMessagePopUp = () => {
        setOpenDelectPopup(true);
    };

    const onDelete = () => {
        if (lineItems?.length == 0) {
            saveCategory(true);
        } else {
            onCategoryDelete();
        }
    };

    const onCategoryDelete = () => {
        callAPI(
            `/admin/category/${id}/delete`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    token: user?.auth_token,
                },
            },
            navigate,
            setLoading,
        ).then((data) => {
            if (data.success) {
                navigate("/admin/categories");
                localStorage.setItem(
                    "Message",
                    categories_page_message?.deleted_message,
                );
            } else {
                const errorObj = data?.errors?.find(
                    (error) => error?.field_name == "category_id",
                );
                if (errorObj) {
                    const errorMessage = errorObj?.message;
                    setAlert({
                        text: errorMessages?.[errorMessage],
                        type: alert_message_type.error,
                    });
                    setOpenDelectPopup(false);
                }
            }
        });
    };

    const onCloseMessagePopUp = () => {
        setOpenDelectPopup(false);
    };

    const onCloseDropdown = () => {
        setMode("close");
        setSearchProductName("");
    };

    return (
        <React.Fragment>
            <button
                className="btn btn-primary saveButton mb-4"
                onClick={saveCategory}
            >
                {category_page_labels?.category_edit_page_labels?.save_btn_label}
            </button>
            {store?.is_separate_store && (
                <button
                    className="btn delectButton mb-4 mx-3"
                    onClick={() => onOpenMessagePopUp()}
                >
                    {category_page_labels?.category_edit_page_labels?.delete_btn_label}
                </button>
            )}
            {openDelectPopup && (
                <PopUpMessage
                    delectMessage={true}
                    isDelect={true}
                    onDelete={onDelete}
                    onClose={onCloseMessagePopUp}
                    recipientsCount={true}
                />
            )}

            {alert?.text == errorMessages?.category_linked_with_product ? (
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
            ) : (
                ""
            )}

            <div className="row">
                <div className="col-lg-8">
                    <div className="card card-default">
                        <div className="card-header card-header-border-bottom">
                            <h2>{category_page_labels?.category_edit_page_labels?.title}</h2>
                        </div>

                        <div className="card-body">
                            <div className="ec-store-uploads">
                                <label className="form-label mandatory_field">
                                    {
                                        category_page_labels?.category_add_and_edit_page_labels
                                            ?.name
                                    }
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    maxLength="100"
                                    onChange={onChangeField}
                                    name="name"
                                    value={formValues["name"] || ""}
                                    disabled={!store?.is_separate_store}
                                />
                                <div className="errorMessage">
                                    <Message
                                        text={
                                            errorMessages[
                                            ErrorMessage({ fieldName: "name", errors })
                                            ] || ErrorMessage({ fieldName: "name", errors })
                                        }
                                        type={"errorMsg"}
                                        showMessage={showErrorMessage}
                                    />
                                </div>
                                <label className="form-label">
                                    {
                                        category_page_labels?.category_add_and_edit_page_labels
                                            ?.description
                                    }
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control slug-title "
                                    rows="4"
                                    cols="50"
                                    maxLength="800"
                                    onChange={onChangeField}
                                    name="description"
                                    disabled={!store?.is_separate_store}
                                    value={formValues["description"] || ""}
                                />
                                <div className="mt-4">
                                    <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="is_parent_category"
                                            id="is_parent_category"
                                            onChange={onChangeField}
                                            disabled={!store?.is_separate_store}
                                            checked={formValues["is_parent_category"] || false}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="is_parent_category"
                                        >
                                            Is Parent Category
                                        </label>
                                    </div>
                                </div>
                                {/* Parent Category dropdown */}
                                <div className="mt-4">
                                    <label className={`form-label ${formValues?.is_parent_category ? '' : 'mandatory_field' }`}>
                                        {category_page_labels?.category_add_and_edit_page_labels?.parent_category}
                                    </label>
                                    <select
                                        className="form-control"
                                        name="parent_category_id"
                                        value={formValues["parent_category_id"] || "" }
                                        onChange={onChangeField}
                                        disabled={formValues["is_parent_category"] || !store?.is_separate_store}
                                    >
                                        <option value="">Select Parent Category</option>
                                        {categories
                                            ?.filter((category) => !category.parent_category_id)
                                            ?.map((category, index) => (
                                                <option key={index} value={category.category_id}>
                                                    {category.name}
                                                </option>
                                            ))}
                                    </select>
                                    {formValues["is_parent_category"] && (
                                        <small className="text-muted">
                                            {" "}
                                            Parent category is disabled when this is a parent category
                                        </small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card card-default mt-5">
                        <div className="card-header card-header-border-bottom">
                            <h2>
                                {
                                    category_page_labels?.category_add_and_edit_page_labels
                                        ?.products_block_title
                                }
                            </h2>
                        </div>
                        <div className="card-body">
                            <div className="productSearchWrapper">
                                <div className="search-form d-lg-inline-block searchWrapper">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            name="query"
                                            id="search-input"
                                            className="form-control searchInput"
                                            placeholder={`${category_page_labels?.category_add_and_edit_page_labels?.products_block_search_placholder}`}
                                            onChange={onSearchProductName}
                                            onClick={() => onClickProductsList()}
                                        />
                                        <span
                                            type="button"
                                            name="search"
                                            id="search-btn"
                                            className="product_search_icon"
                                            onClick={() => onClickProductSearchIcon()}
                                        >
                                            <i className="mdi mdi-magnify icon"></i>
                                        </span>
                                    </div>
                                </div>
                                {mode == "open" && (
                                    <div
                                        className={`${productList ? "categorieList" : "noCategorieList"}`}
                                    >
                                        <ul id={`search-results`}>
                                            {productList?.map((list, index) => {
                                                var defaultSelectedProduct = defaultProduct?.find(
                                                    (item) => item?.product_id == list?.product_id,
                                                );
                                                var alreadySelectedItem = lineItems?.find(
                                                    (item) => item?.product_id == list?.product_id,
                                                );
                                                const isProductInSelected = selectedProducts?.some(
                                                    (selectedProduct) =>
                                                        selectedProduct?.product_id === list?.product_id,
                                                );

                                                return (
                                                    <li
                                                        key={index}
                                                        className={`${isProductInSelected || defaultSelectedProduct ? "hasSelected seletedLineItem" : ""} productDropDown`}
                                                    >
                                                        <div
                                                            className={`${isProductInSelected || defaultSelectedProduct ? "hasSelected seletedLineItem" : ""} w-100`}
                                                            onClick={() =>
                                                                onChangeFields(!alreadySelectedItem, list)
                                                            }
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                id={list?.product_id}
                                                                name={list?.product_id}
                                                                value={list?.product_id}
                                                                checked={
                                                                    isProductInSelected || defaultSelectedProduct
                                                                        ? true
                                                                        : false
                                                                }
                                                                onChange={() => { }}
                                                            />
                                                            <span className="checkBoxLabel">
                                                                {list?.name}
                                                            </span>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                            {productList?.lenght == 0 || productList == "" ? (
                                                <p className="text-center mt-3 mb-5">
                                                    {categories_page_message?.product_not_found}
                                                </p>
                                            ) : (
                                                ""
                                            )}
                                        </ul>
                                        {productList != "" && productList?.lenght != 0 && (
                                            <div className="d-flex productlistbutton mt-3 ">
                                                <button
                                                    className="addButton"
                                                    onClick={onClickAddLineItems}
                                                >
                                                    {
                                                        category_page_labels
                                                            ?.category_add_and_edit_page_labels
                                                            ?.products_block_btn_add
                                                    }
                                                </button>
                                                <button
                                                    className="cancelButton"
                                                    onClick={onClickCloseDropdown}
                                                >
                                                    {
                                                        category_page_labels
                                                            ?.category_add_and_edit_page_labels
                                                            ?.products_block_btn_cancel
                                                    }
                                                </button>
                                                <button
                                                    className="ml-auto addButton"
                                                    onClick={() => onCloseDropdown()}
                                                >
                                                    {
                                                        category_page_labels
                                                            ?.category_add_and_edit_page_labels
                                                            ?.products_block_btn_close
                                                    }
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div>
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <Droppable droppableId="products">
                                        {(provided) => (
                                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                                {lineItems?.map((lineItem, index) => {
                                                    return (
                                                        <Draggable
                                                            key={lineItem?.product_id?.toString()}
                                                            draggableId={lineItem?.product_id?.toString()}
                                                            index={index}
                                                        >
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    className="searchList"
                                                                >
                                                                    <div className="d-flex align-items-center">
                                                                        <i
                                                                            className="mdi mdi-drag mr-2"
                                                                            style={{
                                                                                fontSize: "20px",
                                                                                color: "#8a909d",
                                                                            }}
                                                                        ></i>
                                                                        <span>{lineItem?.name}</span>
                                                                    </div>
                                                                    <span
                                                                        className="removeProduct"
                                                                        onClick={() =>
                                                                            onClickRemoveProduct(
                                                                                index,
                                                                                lineItem?.product_id,
                                                                            )
                                                                        }
                                                                    >
                                                                        <span className="mdi mdi-close"></span>
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                    );
                                                })}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card card-default">
                        <div className="card-body ">
                            <div className="form-group">
                                <label className="form-label">
                                    {
                                        category_page_labels?.category_add_and_edit_page_labels
                                            ?.status
                                    }
                                </label>
                                <select
                                    className="form-control"
                                    name="status"
                                    disabled={!store?.is_separate_store}
                                    onChange={onChangeField}
                                    value={formValues["status"]}
                                >
                                    {status &&
                                        status?.map((optionString, index) => {
                                            const [name, value] = optionString.split(",");
                                            return (
                                                <option value={name} key={index}>
                                                    {value}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5">
                        <div className="card card-default">
                            <div className="card-header card-header-border-bottom">
                                <h2>
                                    {
                                        category_page_labels?.category_add_and_edit_page_labels
                                            ?.category_image_block_title
                                    }
                                </h2>
                            </div>
                            <div className="card-body">
                                <ImagesPreview
                                    acceptMultipleFiles={false}
                                    featuredImage={false}
                                    userProfile={false}
                                    savedImages={savedImages}
                                    onOpen={onOpen}
                                    selectedImageInfo={selectedImages}
                                    onRemoveImageIds={onRemoveImageIds}
                                    deleteDisable={true}
                                />
                            </div>
                        </div>
                    </div>
                    {/* Card for category SEO */}
                    <div className="card card-default mt-5">
                        <div className="card-header card-header-border-bottom">
                            <h2>
                                {
                                    category_page_labels
                                        ?.category_add_and_edit_page_labels?.seo
                                }
                            </h2>
                        </div>
                        <div className="card-body">
                            <div className="ec-store-uploads">
                                <label className="form-label">
                                    {
                                        category_page_labels
                                            ?.category_add_and_edit_page_labels
                                            ?.meta_title
                                    }
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    maxLength="100"
                                    name="meta_title"
                                    onChange={onChangeField}
                                    value={formValues["meta_title"] || ""}
                                    disabled={!store?.is_separate_store}
                                />
                                <label className="form-label">
                                    {
                                        category_page_labels
                                            ?.category_add_and_edit_page_labels
                                            ?.meta_description
                                    }
                                </label>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    rows="4"
                                    cols="50"
                                    name="meta_description"
                                    maxLength="1000"
                                    onChange={onChangeField}
                                    value={formValues["meta_description"] || ""}
                                    disabled={!store?.is_separate_store}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ImageSelector
                Config={imageSelector}
                onClose={onClose}
                onSelectImageInfo={onSelectImages}
            />
            <div className=" mt-4">
                <button className="btn btn-primary" onClick={saveCategory}>
                    {category_page_labels?.category_edit_page_labels?.save_btn_label}
                </button>
            </div>
        </React.Fragment>
    );
}
